module.exports = __webpack_public_path__ + "h5/img/asmpt_logo.bf4d3c7e.svg";